/**
 * SayTextNode.tsx
 * SayTextノードのビューコンポーネント
 * 前のノードから受け取ったテキストを出力するスカイブルーのノード
 */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import type { SayTextNode } from '../../types';
import {
  DEFAULT_SAY_TEXT_SPEAKER,
  SAY_TEXT_VOICES,
} from '../../config/sayTextVoice';
import { CardShell } from '../CardShell';

/**
 * SayTextノードの表示コンポーネント
 * - 入力エリアは持たない（TextEditの値を使用）
 * - 左右に接続ハンドルを持つ
 */
export const SayTextNodeView = memo(function SayTextNodeView({
  data,
}: NodeProps<SayTextNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const voiceLabel = SAY_TEXT_VOICES.find(
    (voice) => voice.speaker === (data.speaker ?? DEFAULT_SAY_TEXT_SPEAKER),
  )?.label ?? '';

  return (
    <CardShell
      kind="sayText"
      accent="sky"
      title={getNodeDisplayLabel('sayText', displayLanguage)}
      summary={voiceLabel}
    >
      <Handle type="target" position={Position.Left} className="!bg-sky-500" />
      <Handle type="source" position={Position.Right} className="!bg-sky-500" />
    </CardShell>
  );
});
